import axios from 'axios';
import { surveyData as defaultSurveyData } from './Constants';

// Environment-based API URL selection
const getBaseUrl = () => {
	if (process.env.REACT_APP_API_ENV === 'production' || true) {
		return 'https://api.alkalmaup.com';
	} else {
		return 'http://localhost:8080';
	}
};

const baseUrl = getBaseUrl();

export async function sendTokenAsync(token) {
	const options = {
		method: 'GET',
		url: `${baseUrl}/api/data_processing_agreement?token=${token}`,
	};
	return axios(options)
		.then((response) => 'ok')
		.catch((error) => 'ok');
}

export async function fetchSurveyData(surveyCode) {
	if (!surveyCode) {
		throw new Error('Survey code is required');
	}

	const options = {
		method: 'GET',
		url: `${baseUrl}/api/survey/${surveyCode}`,
	};

	try {
		const response = await axios(options);
		return response.data;
	} catch (error) {
		console.error('Error fetching survey data:', error);
		throw error;
	}
}
export async function fetchSurveyResults(surveyCode) {
	if (!surveyCode) {
		throw new Error('Survey code is required');
	}

	const options = {
		method: 'GET',
		url: `${baseUrl}/api/survey/${surveyCode}/results`,
	};

	try {
		const response = await axios(options);
		return response.data;
	} catch (error) {
		console.error('Error fetching survey data:', error);
		throw error;
	}
}

export async function submitSurveyResponse(surveyCode, surveyResponses) {
	if (!surveyCode) {
		throw new Error('Survey code is required');
	}

	const options = {
		method: 'POST',
		url: `${baseUrl}/api/survey/${surveyCode}/submit`,
		data: surveyResponses,
	};

	try {
		const response = await axios(options);
		return response.data;
	} catch (error) {
		console.error('Error submitting survey responses:', error);
		throw error;
	}
}
